import React, { Component, Fragment } from 'react';
import { sendMessage } from '../../config/utils/message';
import { GantiPassword } from '../../services/api-services/settings-api';

class Settings extends Component {
    state = {
        dataPassword: { nim: localStorage.getItem('nim'), passlama: '', passbaru: '' },
        message: "-",
        validasi: false
    }
    changePassword = (e) => {
        this.setState({ dataPassword: { ...this.state.dataPassword, [e.target.name]: e.target.value } })
    }
    submitPassword = async (e) => {
        e.preventDefault()
        if (this.state.validasi) {
            const response = await GantiPassword(this.state.dataPassword)
            if (response) {
                sendMessage(response.data.status_code).then(() => { if (response.data.status_code == 200) { window.location.reload(); } })
            }
        }
    }
    matchPassword = (e) => {
        if (e.target.value == this.state.dataPassword.passbaru) {
            this.setState({ dataPassword: { ...this.state.dataPassword, passbaru: e.target.value } })
            this.setState({ message: (<span style={{ color: '#37F062' }}>*password cocok</span>), validasi: true })
        } else {
            this.setState({ message: (<span style={{ color: '#FF3D41' }}>*password tidak cocok</span>), validasi: false })
        }
    }
    render() {
        return (
            <Fragment>
                <div className="smooth mb-2">
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                    Setup Akun&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Ubah Password
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom">
                        <div className="card-body">
                            <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                Ubah Password
                            </p>
                            <form onSubmit={this.submitPassword}>
                                <div className="row pl-3 pr-3 mt-4">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Password Lama :</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                onChange={this.changePassword}
                                                name='passlama'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Password Baru :</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="inputPassword"
                                                onChange={this.changePassword}
                                                name='passbaru'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Ulangi Password :</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="inputPassword"
                                                onChange={this.matchPassword}
                                                name='passbaru'
                                                disabled={this.state.dataPassword.passbaru == "" ? true : false}
                                            />
                                            <p className='mt-2'>{this.state.message}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <p align="right">
                                            <button className='btn btn-success'>simpan</button>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Settings;